import React, { useState } from 'react';

import NotificationPopUp from '../Headers/NotificationPopUp';
import SwitchToPaidConfirmModal from './SwitchToPaidConfirmModal';

function SwitchToPaidModal({
  isOpen,
  onCancel,
  user,
  userSubscription,
  activateSubscription,
  subscriptionActivationSucces,
  subscriptionActivationWaiting,
  subscriptionActivationMessage,
  isForAudio,
}) {
  const [isConfirmationOpen, setConfirmationOpen] = useState(false);

  const notificationInformation = {
    mainButtonLabel: 'Activate Subscription',
    notificationTitle: 'Activate Your Subscription',
    notificationDescription: !isForAudio
      ? 'Activate your subscription to continue studying'
      : 'Activate your subscription to play audio (only annual or semi-annual apply)',
  };

  const handleCancel = () => {
    onCancel(false);
  };

  const handleCloseConfirmation = (activated) => {
    setConfirmationOpen(false);
    onCancel(activated);
  };

  return (
    <>
      <NotificationPopUp
        isOpen={isOpen}
        dontToggle
        openCancelPopUp={handleCancel}
        notificationInformation={notificationInformation}
        mainButtonFunction={() => {
          setConfirmationOpen(true);
        }}
        user={user}
      />
      <SwitchToPaidConfirmModal
        user={user}
        userSubscription={userSubscription}
        isOpen={isConfirmationOpen}
        onClose={(activated) => handleCloseConfirmation(activated)}
        activateSubscription={activateSubscription}
        subscriptionActivationSucces={subscriptionActivationSucces}
        subscriptionActivationWaiting={subscriptionActivationWaiting}
        subscriptionActivationMessage={subscriptionActivationMessage}
      />
    </>
  );
}

export default SwitchToPaidModal;
